import { fetchJson, mutate } from '@/services/roros/base-roros.service';
import type { GenerateCanvasBody, RorosCanvasBlocksDTO, RorosCanvasResponseDTO, RorosCanvasType } from '@/types/roros/canvases';

export const CanvasService = {
  get: (type: RorosCanvasType) =>
    fetchJson<RorosCanvasResponseDTO>(`/api/v1/canvases/${type}`),
  save: (type: RorosCanvasType, blocks: RorosCanvasBlocksDTO) =>
    mutate<RorosCanvasResponseDTO>(`/api/v1/canvases/${type}`, 'PUT', { blocks }),
  generate: (type: RorosCanvasType, body: GenerateCanvasBody) =>
    mutate<RorosCanvasResponseDTO>(`/api/v1/canvases/${type}/generate`, 'POST', body),
};
